"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiEvent = /** @class */ (function (_super) {
    __extends(ApiEvent, _super);
    function ApiEvent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_EVENT_MODAL = '/api/v1/modal';
        _this.GET_GLOBAL_PROCESS = '/api/v1/globalProcess';
        _this.GET_EVENT_MODAL_CHECK = '/api/v1/modal/check';
        _this.GET_CASHBACK_COINSUM = '/api/v1/event/cashback/coinsum';
        _this.UPDATE_PARTNER = '/log/setPartnerCode';
        _this.GET_EVENT_BANNER_DATA_URL = '/api/v1/page/event';
        _this.GET_USER_ID_PROMOTION_TARGET = '/api/v1/event/getUserIdPromotionTarget';
        _this.PUT_USER_ID_PROMOTION = '/api/v1/event/putUserIdPromotion';
        /**
         * 이탈자 방지 API
         * @param reqHeader
         * @param cancel
         * @returns
         */
        _this.getUserIdPromotionTarget = function (accessToken, comicId) {
            return ApiConfig_1.Axios.Client({
                header: {
                    token: accessToken,
                },
                method: 'post',
                data: {
                    comicId: comicId,
                },
                url: _this.GET_USER_ID_PROMOTION_TARGET,
            });
        };
        /**
         * 이탈자 방지 프로모션 지급
         * @param reqHeader
         * @param cancel
         * @returns
         */
        _this.putUserIdPromotion = function (accessToken, comicId) {
            return ApiConfig_1.Axios.Client({
                header: {
                    token: accessToken,
                },
                method: 'post',
                data: {
                    comicId: comicId,
                },
                url: _this.PUT_USER_ID_PROMOTION,
            });
        };
        /**
         * @deprecated
         * 사용자가 확인해야할 event가 있는지 확인하는 api
         * @param token
         */
        _this.getEventModal = function (reqHeader, cancel) {
            var token = reqHeader.token, uuid = reqHeader.uuid;
            return ApiConfig_1.Axios.Client({
                header: {
                    token: token,
                    uuid: uuid,
                },
                method: 'get',
                url: _this.GET_EVENT_MODAL,
                cancelToken: cancel.token,
            });
        };
        /**
         * getEventModal과 병합
         * @param reqHeader
         * @param cancel
         * @returns
         */
        _this.getGLobalProcess = function (reqHeader) {
            var token = reqHeader.token, uuid = reqHeader.uuid, Cookies = reqHeader.Cookies, path = reqHeader.path;
            return ApiConfig_1.Axios.Client({
                header: {
                    token: token,
                    uuid: uuid,
                },
                method: 'post',
                url: _this.GET_GLOBAL_PROCESS,
                data: Cookies ? { Cookies: __assign({}, Cookies), path: path } : null,
            });
        };
        /**
         * 사용자 이벤트 확인 api
         * @param token
         * @param id (이벤트 식별 id)
         */
        _this.checkEventModal = function (reqHeader, id) {
            var token = reqHeader.token;
            return ApiConfig_1.Axios.Client({
                header: {
                    token: token,
                },
                method: 'post',
                url: _this.GET_EVENT_MODAL_CHECK,
                data: {
                    code: id,
                },
            });
        };
        /**
         * 파트너 코드 유입 통계용 api
         * @param token
         * @param pCode
         */
        _this.updatePartnerCode = function (token, params) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'get',
                url: _this.UPDATE_PARTNER,
                params: params,
            });
        };
        /**
         * cashback 코인소모 이벤트 페이지 api
         * @param token
         * @returns
         */
        _this.getCashbackCoinSum = function (token, isAlreadyMature, code) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, isAlreadyMature: isAlreadyMature },
                method: 'get',
                url: _this.GET_CASHBACK_COINSUM,
                params: {
                    code: code,
                },
            });
        };
        _this.getEventBannerData = function (token) {
            return ApiConfig_1.Axios.Client({
                header: {
                    token: token,
                },
                method: 'get',
                url: _this.GET_EVENT_BANNER_DATA_URL,
            });
        };
        _this.eventThemeImageSort = function (token) {
            return ApiConfig_1.Axios.Client({
                header: {
                    token: token,
                },
                method: 'get',
                url: _this.GET_EVENT_BANNER_DATA_URL,
            });
        };
        return _this;
    }
    ApiEvent.getInstance = function (initValue) {
        if (!ApiEvent.classInstance) {
            this.classInstance = new ApiEvent(initValue);
        }
        return this.classInstance;
    };
    return ApiEvent;
}(ApiManager_1.ApiManager));
exports.default = ApiEvent;
